"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60mm",
    height: "60mm",
    viewBox: "0 0 170.08 170.08",
    fill: "#005271"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M154.18,0H15.9q-4.51,0-4.51,4.51V142.79q0,4.52,4.51,4.51H61.15l22.72,22.33a1.69,1.69,0,0,0,1.16.45,1.68,1.68,0,0,0,1.16-.45l22.73-22.33h45.26q4.51,0,4.51-4.51V4.51Q158.69,0,154.18,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M147.65,92.65h-6.81a10.47,10.47,0,0,0-1-.89,20.76,20.76,0,0,0-8.67-39.63h-9.67V50.52a1.88,1.88,0,0,0-1.89-1.89h-10.9a1.89,1.89,0,0,0-1.9,1.89v1.61H60.54V50.52a1.89,1.89,0,0,0-1.9-1.89H47.74a1.89,1.89,0,0,0-1.89,1.89v1.61h-7a20.76,20.76,0,0,0-8.66,39.63,10.59,10.59,0,0,0-1,.89H22.71a2,2,0,0,0-2,2s0,0,0,.05,0,0,0,0a1.9,1.9,0,0,0,1.9,1.9H27a9.87,9.87,0,1,0,19.33,2.8,9.78,9.78,0,0,0-1.88-5.74h4a9.78,9.78,0,0,0-1.87,5.74,9.88,9.88,0,0,0,19.6,1.78h37.8a9.88,9.88,0,0,0,19.6-1.78,9.78,9.78,0,0,0-1.87-5.74h4a9.78,9.78,0,0,0-1.87,5.74,9.89,9.89,0,1,0,19.77,0,9.6,9.6,0,0,0-.45-2.8h4.63a1.89,1.89,0,0,0,1.89-1.9v-.09A2,2,0,0,0,147.65,92.65Zm-15.23,1c.47,0,.94-.06,1.4-.12a5.9,5.9,0,1,1-1.4.12ZM21.91,72.9a17,17,0,0,1,17-17h92.28a17,17,0,0,1,3.06,33.67c-.19,0-.37,0-.56,0a9.93,9.93,0,0,0-2.46.34h-15.1a9.11,9.11,0,0,0-4.93,0H58.89a9.07,9.07,0,0,0-4.92,0H38.86a9.92,9.92,0,0,0-2.45-.34c-.2,0-.38,0-.57,0A17,17,0,0,1,21.91,72.9Zm36,20.78a5.95,5.95,0,1,1-2.91,0Zm57.23,0a6,6,0,1,1-2.91,0Zm-77.45-.07a6,6,0,1,1-1.4-.12C36.72,93.55,37.19,93.59,37.66,93.61Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "71.18",
    y: "59.05",
    width: "27.71",
    height: "27.71",
    fill: "#fff"
  }));
};

exports["default"] = _default;